// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  padding: 0;
  margin: 0;
}

#app-site {
  display: flex;
  width: 100%;
  height: 100vh;
}

.loader {
  position: relative;
  margin: 0 auto;
  width: 60px;
  height: 100%;
}

.loader:before {
  content: "";
  display: block;
  padding-top: 100%;
}

.circular {
  animation: rotate 2s linear infinite;
  -webkit-animation: rotate 2s linear infinite;
  height: auto;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
@keyframes color {
  100%, 0% {
    stroke: #d62d20;
  }
  40% {
    stroke: #0057e7;
  }
  66% {
    stroke: #008744;
  }
  80%, 90% {
    stroke: #ffa700;
  }
}
@-webkit-keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
@-webkit-keyframes color {
  100%, 0% {
    stroke: #d62d20;
  }
  40% {
    stroke: #0057e7;
  }
  66% {
    stroke: #008744;
  }
  80%, 90% {
    stroke: #ffa700;
  }
}
`, "",{"version":3,"sources":["webpack://./assets/src/css/loader.css"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,SAAA;AACJ;;AAEA;EACI,aAAA;EACA,WAAA;EACA,aAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,cAAA;EACA,iBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,4CAAA;EACA,YAAA;EACA,+BAAA;EACA,uCAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AACJ;;AAEA;EACI,wBAAA;EACA,oBAAA;EACA,wEAAA;EACA,gFAAA;EACA,qBAAA;AACJ;;AAEA;EACI;IACI,yBAAA;EACN;AACF;AAEA;EACI;IACI,wBAAA;IACA,oBAAA;EAAN;EAEE;IACI,yBAAA;IACA,wBAAA;EAAN;EAEE;IACI,yBAAA;IACA,yBAAA;EAAN;AACF;AAGA;EACI;IAEI,eAAA;EAFN;EAIE;IACI,eAAA;EAFN;EAIE;IACI,eAAA;EAFN;EAIE;IAEI,eAAA;EAHN;AACF;AAMA;EACI;IACI,yBAAA;EAJN;AACF;AAOA;EACI;IACI,wBAAA;IACA,oBAAA;EALN;EAOE;IACI,yBAAA;IACA,wBAAA;EALN;EAOE;IACI,yBAAA;IACA,yBAAA;EALN;AACF;AAQA;EACI;IAEI,eAAA;EAPN;EASE;IACI,eAAA;EAPN;EASE;IACI,eAAA;EAPN;EASE;IAEI,eAAA;EARN;AACF","sourcesContent":["body {\n    padding: 0;\n    margin: 0;\n}\n\n#app-site {\n    display: flex;\n    width: 100%;\n    height: 100vh;\n}\n\n.loader {\n    position: relative;\n    margin: 0 auto;\n    width: 60px;\n    height: 100%;\n}\n\n.loader:before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n}\n\n.circular {\n    animation: rotate 2s linear infinite;\n    -webkit-animation: rotate 2s linear infinite;\n    height: auto;\n    transform-origin: center center;\n    -webkit-transform-origin: center center;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.path {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n    -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n    stroke-linecap: round;\n}\n\n@keyframes rotate {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes dash {\n    0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n    }\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n    }\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n    }\n}\n\n@keyframes color {\n    100%,\n    0% {\n        stroke: #d62d20;\n    }\n    40% {\n        stroke: #0057e7;\n    }\n    66% {\n        stroke: #008744;\n    }\n    80%,\n    90% {\n        stroke: #ffa700;\n    }\n}\n\n@-webkit-keyframes rotate {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@-webkit-keyframes dash {\n    0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n    }\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n    }\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n    }\n}\n\n@-webkit-keyframes color {\n    100%,\n    0% {\n        stroke: #d62d20;\n    }\n    40% {\n        stroke: #0057e7;\n    }\n    66% {\n        stroke: #008744;\n    }\n    80%,\n    90% {\n        stroke: #ffa700;\n    }\n}\n\n/*# sourceMappingURL=loader.css.map */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
